import { checkPermission } from '@/router/guards.ts'

const ReviewModule = () => import('./FuelStationsReportModule.vue')
const FuelStationsPerformerReportIndex = () =>
  import('./views/FuelStationsPerformerReportIndex.vue')

export const fuelStationsReportRoute = {
  path: '/report',
  component: ReviewModule,
  meta: {
    title: 'Fuel Station Review Reports',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'fuel-stations-performer',
      name: 'fuel-station-reviews-report-index',
      component: FuelStationsPerformerReportIndex,
      meta: {
        permission: 'report.reviews_fuel_station',
      },
      beforeEnter: checkPermission('report.reviews_fuel_station'),
    },
  ],
}
